import type { Annotation, AnnotationPoint } from './annotation';
import type { HandleId } from './handle';

export enum DragMode {
  None = 'none',
  Draw = 'draw',
  Move = 'move',
  Resize = 'resize',
}

/** Mid-drag scratchpad held in a ref by the pointer-interactions hook. */
export interface DragContext {
  dragStartSnapshot: Annotation | null;
  dragStartPoint: AnnotationPoint | null;
  activeHandle: HandleId | null;
  drawStartPoint: AnnotationPoint | null;
  currentDraft: Annotation | null;
}
